"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultStrokeWidth = void 0;
var round_1 = require("../../round");
var MODAL_MARGIN = 30;
var TOP_BAR_HEIGHT = 40;
var BOTTOM_BAR_HEIGHT = 100;
/**
 * With our previous markup library (node-markup) we used a 5px stroke width on medium images.
 * An example medium image had a height of 444px and a width of 592px.
 */
var strokeToHeight = 5 / 444;
var strokeToWidth = 5 / 592;
function getDefaultStrokeWidth() {
    var vh = document.documentElement.clientHeight;
    var vw = document.documentElement.clientWidth;
    var maxImageHeight = vh - 2 * MODAL_MARGIN - TOP_BAR_HEIGHT - BOTTOM_BAR_HEIGHT;
    var maxImageWidth = vw - 2 * MODAL_MARGIN;
    if (maxImageWidth < maxImageHeight) {
        // Width is the limiting factor to size the image in the editor
        return (0, round_1.round)(maxImageWidth * strokeToWidth, 1);
    }
    else {
        // Height is the limiting factor to size the image in the editor
        return (0, round_1.round)(maxImageHeight * strokeToHeight, 1);
    }
}
exports.getDefaultStrokeWidth = getDefaultStrokeWidth;
